/* eslint-disable */
import {
  Avatar,
  Flex,
  Text,
  useColorModeValue,
  useColorMode,
  useBreakpointValue,
  Badge,
  HStack,
  VStack,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FiLogOut, FiUser } from "react-icons/fi";
import { useAuth } from "contexts/AuthContext";
import React, { useState } from "react";
import { changePassword } from "services/auth";

export default function AdminNavbarLinks(props) {
  const { onOpen } = props;
  const { user = {}, logout } = useAuth?.() || {};
  const menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const subtle = useColorModeValue("gray.600", "gray.400");
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen: isPwdOpen, onOpen: onPwdOpen, onClose: onPwdClose } = useDisclosure();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLogout = async () => {
    try {
      if (logout) await logout();
    } catch {}
    navigate("/auth/sign-in");
  };

  const handleChangePassword = async () => {
    setSubmitting(true);
    try {
      await changePassword({ currentPassword, newPassword, newPassword2 });
      toast({ status: "success", title: "비밀번호가 변경되었습니다." });
      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
      onPwdClose();
    } catch (err) {
      console.error(err);
      toast({
        status: "error",
        title: "비밀번호 변경에 실패했습니다.",
        description: "입력값을 확인하거나 다시 시도해 주세요.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const userId = user?.email || user?.name || "guest";
  const displayName = user?.name || "User";
  const role = user?.role || "user";
  const isSuperAdminRole = role === "super_admin";
  const roleLabel = isSuperAdminRole ? "super admin" : role;
  const roleBadgeColor = isSuperAdminRole ? "blue" : "gray";
  const linkColor = useColorModeValue("blue.600", "blue.300");

  const isDesktop = useBreakpointValue({ base: false, xl: true });

  return (
    <Flex
      w="100%"
      align={isDesktop ? "center" : "flex-start"}
      justify="flex-start"
      bg={isDesktop ? "transparent" : menuBg}
      p={isDesktop ? "0" : "10px 12px"}
      gap={isDesktop ? "12px" : "10px"}
      border="none"
      boxShadow="none"
      flexWrap="wrap"
    >
      {/*
        프로필 + 관련 액션: 모바일에서는 왼쪽 정렬을 유지하면서 바로 옆에 아이콘을 붙임
      */}
      <HStack spacing="10px" align="center" flexShrink={0}>
        <Avatar
          color="white"
          name={displayName}
          bg="#11047A"
          size="sm"
          w="40px"
          h="40px"
        />

        {/* Mobile: only show avatars here, action icons move next to user info below */}
      </HStack>

      {/* 사용자 정보 */}
      {isDesktop ? (
        <Flex align="center" flex="1" justify="space-between" minW={0}>
          <HStack
            spacing={2}
            minW={0}
            cursor="pointer"
            role="group"
            onClick={onPwdOpen}
            _hover={{ opacity: 0.85 }}
          >
            <Text
              fontSize="sm"
              color={textColor}
              fontWeight="600"
              noOfLines={1}
              minW={0}
              transition="color 0.2s ease"
              _groupHover={{ color: linkColor, textDecoration: "underline" }}
            >
              {userId}
            </Text>
            <Badge
              colorScheme={roleBadgeColor}
              ml={0}
              px="6px"
              py="1px"
              borderRadius="6px"
              transition="color 0.2s ease"
              _groupHover={{ color: linkColor }}
            >
              {roleLabel}
            </Badge>
          </HStack>
          <HStack spacing="6px">
            <IconButton
              aria-label="로그아웃"
              icon={<FiLogOut size={16} />}
              size="sm"
              variant="ghost"
              color="red.400"
              onClick={() => {
                handleLogout();
              }}
            />
          </HStack>
        </Flex>
      ) : (
        <VStack align="start" spacing="2px" minW={0} flex="1">
          <Flex w="100%" align="center" justify="space-between">
            <Text fontSize="sm" fontWeight="700" color={textColor} noOfLines={1} minW={0}>
              {displayName}
            </Text>
            <HStack spacing="6px">
              <IconButton
                aria-label="비밀번호 변경"
                icon={<FiUser size={16} />}
                size="sm"
                variant="ghost"
                color={textColor}
                onClick={onPwdOpen}
              />
              <IconButton
                aria-label="로그아웃"
                icon={<FiLogOut size={16} />}
                size="sm"
                variant="ghost"
                color="red.400"
                onClick={() => {
                  handleLogout();
                }}
              />
            </HStack>
          </Flex>
          <HStack spacing="8px" minW={0}>
            <Text
              fontSize="xs"
              color={subtle}
              noOfLines={1}
              minW={0}
              maxW="60vw"
            >
              {userId}
            </Text>
            <Badge
              variant="subtle"
              colorScheme={isSuperAdminRole ? "blue" : colorMode === "light" ? "blue" : "purple"}
              fontSize="0.65rem"
              borderRadius="6px"
              px="6px"
              py="1px"
              flexShrink={0}
            >
              {roleLabel}
            </Badge>
          </HStack>
        </VStack>
      )}

      <Modal isOpen={isPwdOpen} onClose={onPwdClose} isCentered size="sm" motionPreset="slideInBottom">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>비밀번호 변경</ModalHeader>
          <ModalBody>
            <VStack spacing="12px">
              <FormControl>
                <FormLabel>현재 비밀번호</FormLabel>
                <Input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>새 비밀번호</FormLabel>
                <Input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>새 비밀번호 확인</FormLabel>
                <Input
                  type="password"
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter gap="10px">
            <Button variant="ghost" onClick={onPwdClose} disabled={submitting}>
              취소
            </Button>
            <Button colorScheme="blue" onClick={handleChangePassword} isLoading={submitting}>
              저장
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
